export const ECO_MODE = 'ECO';
export const PERFORMANCE_MODE = 'PERFORMANCE';
